import * as React from "react";
import {
  ActivityFragment,
  CampaignMinimalFragment,
  MadMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { MadIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type MadCreatedActivity = ActivityFragment & {
  recipient: CampaignMinimalFragment;
  trackable: MadMinimalFragment;
};

export function isMadCreatedActivity(
  q: ActivityFragment
): q is MadCreatedActivity {
  return q.key === "mad.created";
}

interface MadCreatedActivityProps {
  activity: MadCreatedActivity;
}

export const MadCreatedActivity: React.FC<MadCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="madCreatedActivity"
      visual={<MadIcon iconClassName="w-10 h-10 text-secondary-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.madCreated", {
          mad: (
            <Link
              to={`/mads/${activity.trackable.id}`}
              key={activity.id}
            >
              {t("activity.objects.mad")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
